import BioModal from "@vg-faset/ui/src/components/bio-modal/BioModal";
import { cloneDeep } from "lodash";
import { EventBus } from "../index.js";
const missingImage = require("./assets/missing-profile-image.png");

export default {
	created() {
		// add the missing profile image to bios that are missing an image
		// and create a new instance of the Modal for each bio and add it
		this.bios = this.bios.map((bio) => {
			if (!bio.img) {
				bio.img = this.placeholder || missingImage;
			}
			let Modal = cloneDeep(BioModal);
			Modal.beforeMount = function () {
				this.update(bio);
			};
			bio.bioComponent = Modal;
			return bio;
		});
	},
	methods: {
		handleBio(e, person) {
			e.preventDefault();
			EventBus.$emit("modal:set-title", "Biography for: " + person.full_name);
			EventBus.$emit("modal:set-id", "bio-modal-id");
			EventBus.$emit("modal:set", person.bioComponent);
			EventBus.$emit("modal:show");
		}
	}
};
